module.exports = __webpack_public_path__ + "img/3.71fc99fb.png";